/* eslint-disable complexity */
import { makeAPICaller } from 'src/utils/fetch';
import { StakingPlan } from 'src/models';
import { parseBoxConfigs, parseBoxConfigsV2, parseBoxInfo, parseCosmeticDetail, parseCosmeticSaleHistory, parseDescriptionConfigs, parseHeroRental, parseLeaderboardData, parseMyStaking, parseNftCosmetic, parseNftHero, parsePaymentToken, parseRentalConfigs, parseSkinConfig, parseStakingConfig, parseProjectDetail, parseFusionSeason, parseBattleCapHeroData, parseFusionLeaderboardData, parseSpecialEventProfile, parseQuestLeaderboardData, parseGiftBoxInfo, parseMyQuestStagesData, parseQuestCountInStage, parseDailyQuestReward, parseQuestPointEachStageData, parseStagesRewardData, parseQuestBox, parseNftHeroRecently, parseNftCosmeticRecently, parseTradingEventWarmup, parsePopupConfig, parseGiftmasWheel, parseBoxConfig, parseSkinConfigEntities } from './utils';
import { AppError } from './types';
import { BoxType, HeroStatus, HeroTrophy, NftHeroRole, NftItemRarity, NftRefType, NftSkinItemRarity, NtfHeroClassType, TradingQuestType } from 'src/utils/types';
import { CurrencyType, normalNumberToSystemCurrency, serverCurrencyToSystemCurrency, unsafeServerCurrencyToSystemCurrency } from '@wolffun/system-currency';
import { RewardType } from 'src/models';
export const searchNftItem = makeAPICaller('theta_data_get', '/nif/search', response => {
  const {
    page,
    data: items
  } = response || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(items) ? items.map(parseNftHero) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const searchHeroRental = makeAPICaller('theta_data_get', '/nif/search', response => {
  const {
    page,
    data: items
  } = response || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(items) ? items.map(parseHeroRental) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getEstimateApr = makeAPICaller('theta_data_get', '/staking/estimate-apr', response => {
  const {
    data
  } = response || {};
  const defaultData = {
    [StakingPlan.FLEXIBLE]: 0,
    [StakingPlan.ONE_YEAR]: 0,
    [StakingPlan.SIX_MONTHS]: 0
  };
  return {
    status: 'ok',
    body: {
      data: Array.isArray(data) ? data.reduce((result, currentPlan) => {
        const {
          plan,
          apr
        } = currentPlan || {};

        if (typeof plan === 'number') {
          result[plan] = typeof apr === 'number' ? apr : 0;
        }

        return result;
      }, defaultData) : defaultData
    }
  };
});
export const postUnStaking = makeAPICaller('theta_data_post', '/staking/unstake', response => {
  const {
    data
  } = response || {};
  const {
    signature,
    signatureExpiredAt
  } = data || {};
  return {
    status: 'ok',
    body: {
      signature: typeof signature === 'string' ? signature : '',
      signatureExpiredAt: typeof signatureExpiredAt === 'number' ? signatureExpiredAt : 0
    }
  };
});
export const postClaimStakingReward = makeAPICaller('theta_data_post', '/staking/claim-reward', () => {
  return {
    status: 'ok',
    body: {
      success: true
    }
  };
});
export const getStakingConfig = makeAPICaller('theta_data_get', '/staking/configs', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: data ? parseStakingConfig(data) : undefined
    }
  };
});
export const getProjectDetail = makeAPICaller('theta_data_get', '/private-sales/projects/{id}', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: data ? parseProjectDetail(data) : undefined
    }
  };
});
export const getPrivateSaleConfig = makeAPICaller('theta_data_get', '/private-sales/configs', response => {
  const {
    youtubeURL
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      youtubeURL: typeof youtubeURL === 'string' ? youtubeURL : undefined
    }
  };
});
export const getThcExchangeRate = makeAPICaller('theta_data_get', '/private-sales/thc-price', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: {
        rate: typeof (data === null || data === void 0 ? void 0 : data.thcPrice) === 'number' ? data.thcPrice : 0,
        expiredAt: typeof (data === null || data === void 0 ? void 0 : data.expiredAt) === 'number' ? data.expiredAt : 0
      }
    }
  };
});
export const postBuyPrivateSale = makeAPICaller('theta_data_post', '/private-sales/buy', response => {
  const {
    data
  } = response || {};
  const {
    blockchainID,
    expiredAt,
    signature,
    sender,
    busd,
    thc
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        blockchainID: typeof blockchainID === 'number' ? blockchainID : 0,
        expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
        signature: typeof signature === 'string' ? signature : '',
        sender: typeof sender === 'string' ? sender : '',
        busd: serverCurrencyToSystemCurrency(busd),
        thc: serverCurrencyToSystemCurrency(thc)
      }
    }
  };
});
export const getStakingStats = makeAPICaller('theta_data_get', '/staking/stats', response => {
  const {
    data
  } = response || {};
  const {
    thgPrice,
    thgChangePercent,
    thgStaked,
    rewards,
    circulatingSupply,
    thgPlanStaked
  } = data || {};
  const {
    privateTickets,
    staking
  } = rewards || {};
  const defaultData = {
    [StakingPlan.FLEXIBLE]: {},
    [StakingPlan.ONE_YEAR]: {},
    [StakingPlan.SIX_MONTHS]: {}
  };
  return {
    status: 'ok',
    body: {
      data: {
        circulatingSupply: unsafeServerCurrencyToSystemCurrency(circulatingSupply),
        rewards: {
          privateTickets: unsafeServerCurrencyToSystemCurrency(privateTickets),
          staking: unsafeServerCurrencyToSystemCurrency(staking)
        },
        thgChangePercent: typeof thgChangePercent === 'number' ? thgChangePercent : 0,
        thgPrice: serverCurrencyToSystemCurrency(thgPrice),
        thgStaked: unsafeServerCurrencyToSystemCurrency(thgStaked),
        thgPlanStaked: Array.isArray(thgPlanStaked) ? thgPlanStaked.reduce((result, currentPlan) => {
          const {
            plan,
            amount,
            stakeable
          } = currentPlan || {};

          if (typeof plan === 'number') {
            result[plan] = {
              amount: unsafeServerCurrencyToSystemCurrency(amount),
              stakeable: serverCurrencyToSystemCurrency(stakeable)
            };
          }

          return result;
        }, defaultData) : defaultData
      }
    }
  };
});
export const claimBox = makeAPICaller('theta_data_post', '/thetanbox/bclaim', response => {
  const {
    data
  } = response || {};
  const {
    userId,
    userAddress,
    tokenId,
    timestamp,
    boxId,
    boxType
  } = data || {};
  return {
    status: 'ok',
    body: {
      userId: typeof userId === 'string' ? userId : '',
      userAddress: typeof userAddress === 'string' ? userAddress : '',
      boxId: typeof boxId === 'number' ? boxId : '',
      timestamp: typeof timestamp === 'number' ? timestamp : undefined,
      boxType: typeof boxType === 'number' ? boxType : BoxType.COMMON,
      tokenId: typeof tokenId === 'string' ? tokenId : ''
    }
  };
});
export const searchClaimBoxes = makeAPICaller('theta_data_get', '/thetanbox/bclaim', response => {
  const {
    page,
    data: items
  } = response || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(items) ? items.map(item => {
    const {
      userId,
      userAddress,
      tokenId,
      timestamp,
      boxId,
      boxType
    } = item || {};
    return {
      userId: typeof userId === 'string' ? userId : '',
      userAddress: typeof userAddress === 'string' ? userAddress : '',
      boxId: typeof boxId === 'number' ? boxId : '',
      timestamp: typeof timestamp === 'number' ? timestamp : undefined,
      boxType: typeof boxType === 'number' ? boxType : BoxType.COMMON,
      tokenId: typeof tokenId === 'string' ? tokenId : ''
    };
  }) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getHeroInfo = makeAPICaller('theta_data_get', '/hero', response => {
  const {
    data
  } = response || {};
  const {
    heroInfo,
    heroRanking,
    skinInfo,
    sale,
    rentInfo,
    blockchainId
  } = data || {};

  if (!data || !heroInfo || !heroRanking || !skinInfo) {
    return {
      status: 'error',
      error: AppError.REJECTED_BY_FE,
      debugMessage: 'missing data?'
    };
  }

  return {
    status: 'ok',
    body: {
      item: {
        hero: {
          createdAt: typeof data.created === 'string' ? data.created : '',
          updatedAt: typeof data.lastModified === 'string' ? data.lastModified : '',
          id: typeof data.id === 'string' ? data.id : '',
          userId: typeof data.userId === 'string' ? data.userId : '',
          userUsingId: typeof data.userUsingId === 'string' ? data.userUsingId : '',
          userAddress: typeof data.ownerAddress === 'string' ? data.ownerAddress : '',
          heroTypeId: typeof data.heroTypeId === 'number' ? data.heroTypeId : 0,
          blockchainId: typeof blockchainId === 'number' ? blockchainId : 0,
          skinId: typeof data.skinId === 'number' ? data.skinId : 0,
          rarity: typeof data.rarity === 'number' ? data.rarity : NftItemRarity.COMMON,
          status: typeof data.status === 'number' ? data.status : HeroStatus.DEFAULT,
          skinRarity: typeof data.skinRarity === 'number' ? data.skinRarity : NftSkinItemRarity.NORMAL,
          season: typeof data.season === 'number' ? data.season : 0,
          level: typeof data.level === 'number' ? data.level : 0,
          trophy: typeof heroRanking.trophyClass === 'number' ? heroRanking.trophyClass : HeroTrophy.H,
          source: typeof data.source === 'string' ? data.source : '',
          tokenId: typeof data.tokenId === 'string' ? data.tokenId : '',
          nftId: typeof data.nftId === 'string' ? data.nftId : '',
          battleCapTHC: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.battleCapTHC) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.battleCapTHC : 0,
          totalBattleCapTHC: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.totalBattleCapTHC) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.totalBattleCapTHC : 0,
          dailyTHCBattleCap: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.dailyTHCBattleCap) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.dailyTHCBattleCap : 0,
          dailyTHCBattleConfig: typeof data.dailyTHCBattleConfig === 'number' ? data.dailyTHCBattleConfig : 0,
          thcBonus: typeof data.thcBonus === 'number' ? data.thcBonus : 0,
          rentInfo: {
            cost: rentInfo !== null && rentInfo !== void 0 && rentInfo.cost ? serverCurrencyToSystemCurrency(rentInfo.cost) : undefined,
            periodHours: typeof (rentInfo === null || rentInfo === void 0 ? void 0 : rentInfo.periodHours) === 'number' ? rentInfo.periodHours : 0,
            expiredTime: typeof (rentInfo === null || rentInfo === void 0 ? void 0 : rentInfo.expiredTime) === 'number' ? rentInfo === null || rentInfo === void 0 ? void 0 : rentInfo.expiredTime : 0,
            rentBattles: typeof (rentInfo === null || rentInfo === void 0 ? void 0 : rentInfo.rentBattles) === 'number' ? rentInfo.rentBattles : 0,
            winRateTHC: Object.entries((rentInfo === null || rentInfo === void 0 ? void 0 : rentInfo.winRateTHC) || {}).reduce((pre, [key, value]) => {
              return { ...pre,
                [Number(key)]: typeof value === 'number' ? value : 0
              };
            }, {})
          },
          systemPrice: sale !== null && sale !== void 0 && sale.price ? serverCurrencyToSystemCurrency(sale === null || sale === void 0 ? void 0 : sale.price) : undefined,
          lastPrice: data !== null && data !== void 0 && data.lastPrice ? serverCurrencyToSystemCurrency(data === null || data === void 0 ? void 0 : data.lastPrice) : undefined
        },
        heroType: {
          id: typeof data.heroTypeId === 'number' ? data.heroTypeId : 0,
          name: typeof heroInfo.name === 'string' ? heroInfo.name : '',
          rarity: typeof data.rarity === 'number' ? data.rarity : NftItemRarity.COMMON,
          role: typeof heroInfo.role === 'string' ? heroInfo.role : NftHeroRole.ASSASSIN,
          dmg: typeof heroInfo.dmg === 'number' ? heroInfo.dmg : 0,
          hp: typeof heroInfo.hp === 'number' ? heroInfo.hp : 0,
          attackSpeed: typeof heroInfo.atkSpeed === 'number' ? heroInfo.atkSpeed : 0,
          speed: typeof heroInfo.speed === 'number' ? heroInfo.speed : 0
        },
        skin: {
          id: typeof data.skinId === 'number' ? data.skinId : 0,
          heroRarity: typeof skinInfo.heroRarity === 'number' ? skinInfo.heroRarity : NftItemRarity.COMMON,
          skinRarity: typeof data.skinRarity === 'number' ? data.skinRarity : NftSkinItemRarity.NORMAL,
          imageAvatar: typeof skinInfo.imageAvatar === 'string' ? skinInfo.imageAvatar : '',
          imageFull: typeof skinInfo.imageFull === 'string' ? skinInfo.imageFull : '',
          costThetaCoin: typeof skinInfo.cost === 'number' ? skinInfo.cost : 0,
          name: typeof skinInfo.name === 'string' ? skinInfo.name : '',
          isListMarket: typeof skinInfo.isListMarket === 'boolean' ? skinInfo.isListMarket : false,
          model3D: typeof skinInfo.model3D === 'string' ? skinInfo.model3D : undefined,
          scaleRatio: typeof skinInfo.scaleRatio === 'number' ? skinInfo.scaleRatio : undefined
        }
      }
    }
  };
});
export const getHeroUpgradeCost = makeAPICaller('theta_data_get', '/hero/upgradePrice', response => {
  const {
    costGTHG,
    costPP,
    expiredTime
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      data: {
        gthgCost: serverCurrencyToSystemCurrency(costGTHG),
        ppCost: serverCurrencyToSystemCurrency(costPP),
        expiredTime: typeof expiredTime === 'number' ? expiredTime : 0
      }
    }
  };
});
export const upgradeHero = makeAPICaller('theta_data_post', '/hero/upgrade', response => {
  const {
    code
  } = response || {};
  return {
    status: 'ok',
    body: {
      id: typeof code === 'number' ? code : 0
    }
  };
});
export const getItemTransactionFee = makeAPICaller('theta_marketplace_get', '/nif/transaction-fee', response => {
  const {
    rental,
    sale
  } = response || {};
  return {
    status: 'ok',
    body: {
      rental: typeof rental === 'number' ? rental / 100 : 0,
      sale: typeof sale === 'number' ? sale / 100 : 0
    }
  };
});
export const getSaleHistoryListBid = makeAPICaller('theta_marketplace_get', '/sale-bids', response => {
  const {
    items
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: (Array.isArray(items) ? items : []).map(item => {
        const {
          systemCurrency,
          name,
          bidUserAddress,
          bidUsername,
          saleUsername,
          saleUserAddress,
          id,
          created
        } = item || {};
        return {
          name: typeof name === 'string' ? name : '',
          systemPrice: serverCurrencyToSystemCurrency(systemCurrency),
          bidUserAddress: typeof bidUserAddress === 'string' ? bidUserAddress : '',
          bidUsername: typeof bidUsername === 'string' ? bidUsername : '',
          saleUserAddress: typeof saleUserAddress === 'string' ? saleUserAddress : '',
          saleUsername: typeof saleUsername === 'string' ? saleUsername : '',
          id: typeof id === 'string' ? id : '',
          created: !isNaN(Date.parse(created)) ? new Date(created) : undefined
        };
      })
    }
  };
});
export const getSaleItemTransactionHashMessage = makeAPICaller('theta_marketplace_get', '/user-items/{id}/hash-message', response => {
  return {
    status: 'ok',
    body: typeof response === 'string' ? response : ''
  };
});
export const signSellingSignature = makeAPICaller('theta_data_post', '/marketplaces/sign-selling-signature', response => {
  const {
    price,
    signature,
    bid,
    nftAddress,
    tokenId,
    expiredAt,
    paymentTokenAddress
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      signature: typeof signature === 'string' ? signature : '',
      price: serverCurrencyToSystemCurrency(price),
      nftAddress: typeof nftAddress === 'string' ? nftAddress : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      paymentTokenAddress: typeof paymentTokenAddress === 'string' ? paymentTokenAddress : '',
      blockchainId: typeof bid === 'number' ? bid : 0
    }
  };
});
export const signSellingSignatureCosmetic = makeAPICaller('theta_data_post', '/cosmetics/sign-selling-signature', response => {
  const {
    price,
    signature,
    bid,
    nftAddress,
    tokenId,
    expiredAt,
    paymentTokenAddress
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      signature: typeof signature === 'string' ? signature : '',
      price: serverCurrencyToSystemCurrency(price),
      nftAddress: typeof nftAddress === 'string' ? nftAddress : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      paymentTokenAddress: typeof paymentTokenAddress === 'string' ? paymentTokenAddress : '',
      blockchainId: typeof bid === 'number' ? bid : 0
    }
  };
});
export const signLendingSignature = makeAPICaller('theta_data_post', '/rental/sign/lending', response => {
  const {
    price,
    signature,
    bid,
    tokenId,
    expiredAt
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      signature: typeof signature === 'string' ? signature : '',
      price: serverCurrencyToSystemCurrency(price),
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      blockchainId: typeof bid === 'number' ? bid : 0
    }
  };
});
export const signUnlockSignature = makeAPICaller('theta_data_post', '/rental/sign/unlock', response => {
  const {
    bid,
    signature,
    tokenId,
    expiredAt,
    old
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      signature: typeof signature === 'string' ? signature : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      blockchainId: typeof bid === 'number' ? bid : 0,
      old: typeof old === 'boolean' ? old : false
    }
  };
});
export const signMintHeroSignature = makeAPICaller('theta_data_post', '/nft-items/sign-mint-signature', response => {
  const {
    bid,
    signature,
    tokenId,
    expiredAt,
    sender
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      sender: typeof sender === 'string' ? sender : '',
      signature: typeof signature === 'string' ? signature : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      blockchainId: typeof bid === 'number' ? bid : 0
    }
  };
});
export const signMintCosmeticSignature = makeAPICaller('theta_data_post', '/cosmetics/sign/mint', response => {
  const {
    bid,
    signature,
    tokenId,
    expiredAt,
    sender
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      sender: typeof sender === 'string' ? sender : '',
      signature: typeof signature === 'string' ? signature : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      tokenId: typeof tokenId === 'number' ? tokenId : 0,
      blockchainId: typeof bid === 'number' ? bid : 0
    }
  };
});
export const getPaymentTokens = makeAPICaller('theta_marketplace_get', '/payment-tokens', response => {
  const parsedData = Array.isArray(response) ? response.map(parsePaymentToken) : [];
  return {
    status: 'ok',
    body: {
      data: parsedData
    }
  };
});
export const deleteStopSellingItem = makeAPICaller('theta_marketplace_delete', '/user-items/{id}/sale', response => {
  return {
    status: 'ok',
    body: {
      id: typeof response === 'string' ? response : ''
    }
  };
});
export const getHeroDescription = makeAPICaller('theta_data_get', '/hero/feConfigs', res => {
  const {
    version,
    configs,
    battleRewards
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      configVer: typeof version === 'number' ? version : undefined,
      descriptionConfigs: configs ? parseDescriptionConfigs(configs) : undefined,
      reward: {
        win: battleRewards && typeof battleRewards['1'] === 'number' ? battleRewards['1'] : 0,
        lose: battleRewards && typeof battleRewards['-1'] === 'number' ? battleRewards['-1'] : 0,
        draw: battleRewards && typeof battleRewards['0'] === 'number' ? battleRewards['0'] : 0
      }
    }
  };
});
export const getMintConfig = makeAPICaller('theta_data_get', '/marketplaces/config', res => {
  const {
    conditionMintHeroLevelMin,
    conditionMintCosmeticRankLevelMin
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      data: {
        minRankLevel: typeof conditionMintCosmeticRankLevelMin === 'number' ? conditionMintCosmeticRankLevelMin : 0,
        minHeroLevel: typeof conditionMintHeroLevelMin === 'number' ? conditionMintHeroLevelMin : 0
      }
    }
  };
});
export const getRentalConfig = makeAPICaller('theta_data_get', '/hero/rentalConfig', res => {
  const {
    data
  } = res || {};
  return {
    status: 'ok',
    body: {
      configVer: typeof (data === null || data === void 0 ? void 0 : data.version) === 'number' ? data.version : undefined,
      data: parseRentalConfigs(data)
    }
  };
});
export const getUserThetanBoxDetail = makeAPICaller('theta_data_get', '/thetanbox/detail', res => {
  const {
    amount,
    boxConfig,
    skinConfigs,
    boxConfigs
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const {
    boxType,
    configs
  } = boxConfig || {};
  return {
    status: 'ok',
    body: {
      amount: typeof amount === 'number' ? amount : 0,
      boxConfig: boxConfig ? {
        configs: Array.isArray(configs) ? configs.map(e => {
          const {
            heroRarity,
            rate,
            skinRarity
          } = e;
          return {
            heroRarity,
            rate,
            skinRarity
          };
        }) : undefined,
        boxType: typeof boxType === 'number' ? boxType : 0
      } : undefined,
      skinConfigs: parseSkinConfig(skinConfigs),
      boxConfigVer: typeof (boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version) === 'number' ? boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version : undefined,
      boxConfigs: boxConfigs ? parseBoxConfigs(boxConfigs) : undefined
    }
  };
});
export const getUserGiftBoxDetail = makeAPICaller('theta_data_get', '/thetanbox/giftbox/detail', res => {
  const {
    amount,
    isInstalledGame,
    openTime
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      amount: typeof amount === 'number' ? amount : 0,
      isInstalledGame: typeof isInstalledGame === 'boolean' ? isInstalledGame : false,
      openTime: typeof openTime === 'number' ? openTime : 0
    }
  };
});
export const getThetanBoxDashboard = makeAPICaller('theta_data_get', '/thetanbox/dashboard', res => {
  const {
    systemBoxInfos,
    boxSeasonInfo,
    bundleInfos,
    curSeasonId
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const {
    BoxSeasonInfo,
    userBoughtAmount,
    userLimitAmount
  } = boxSeasonInfo || {};
  return {
    status: 'ok',
    body: {
      systemBoxInfos: Array.isArray(systemBoxInfos) ? systemBoxInfos.map(({
        boxType,
        amount,
        totalAmount,
        systemPrice,
        isSale
      }) => ({
        boxType: typeof boxType === 'number' ? boxType : 0,
        amount: typeof amount === 'number' ? amount : 0,
        totalAmount: typeof totalAmount === 'number' ? totalAmount : 0,
        systemPrice: serverCurrencyToSystemCurrency(systemPrice),
        isSale: typeof isSale === 'boolean' ? isSale : false
      })) : // .sort((x, y) => x.boxType - y.boxType)
      [],
      boxSeasonInfo: {
        startTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime) === 'string' && !isNaN(Date.parse(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime)) ? new Date(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime).getTime() : new Date().getTime(),
        endTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.endTime) === 'string' && !isNaN(Date.parse(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.endTime)) ? new Date(BoxSeasonInfo.endTime).getTime() : new Date().getTime(),
        unlimitedAmount: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedAmount) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedAmount : false,
        unlimitedBuy: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedBuy) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedBuy : false,
        unlimitedTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedTime) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedTime : false,
        paymentToken: parsePaymentToken(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.paymentToken),
        userBoughtAmount: typeof userBoughtAmount === 'number' ? userBoughtAmount : 0,
        userLimitAmount: typeof userLimitAmount === 'number' ? userLimitAmount : 0
      },
      bundleBoxInfo: Array.isArray(bundleInfos) ? bundleInfos.map(({
        amount,
        boxType,
        gifts,
        originalPrice,
        systemPrice,
        totalAmount
      }) => ({
        amount: typeof amount === 'number' ? amount : 0,
        boxType: typeof boxType === 'number' ? boxType : 0,
        gifts: Array.isArray(gifts) ? gifts.map(gift => typeof gift === 'number' ? gift : 0) : [],
        originalPrice: serverCurrencyToSystemCurrency(originalPrice),
        systemPrice: serverCurrencyToSystemCurrency(systemPrice),
        totalAmount: typeof totalAmount === 'number' ? totalAmount : 0
      })) : undefined,
      curSeasonId: typeof curSeasonId === 'number' ? curSeasonId : 0
    }
  };
});
export const getGiftBoxDashboard = makeAPICaller('theta_data_get', '/thetanbox/giftbox/dashboard', res => {
  const {
    systemBoxInfos,
    boxSeasonInfo,
    curSeasonId
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const {
    BoxSeasonInfo,
    userBoughtAmount,
    userLimitAmount
  } = boxSeasonInfo || {};
  return {
    status: 'ok',
    body: {
      systemBoxInfos: Array.isArray(systemBoxInfos) ? systemBoxInfos.map(({
        boxType,
        amount,
        totalAmount,
        systemPrice,
        isSale,
        expiredAt,
        weeklyLimit,
        currentWeekOpen,
        totalLimit
      }) => ({
        boxType: typeof boxType === 'number' ? boxType : 0,
        amount: typeof amount === 'number' ? amount : 0,
        totalAmount: typeof totalAmount === 'number' ? totalAmount : 0,
        systemPrice: serverCurrencyToSystemCurrency(systemPrice),
        isSale: typeof isSale === 'boolean' ? isSale : false,
        expiredAt: typeof expiredAt === 'number' ? expiredAt * 1000 : undefined,
        currentWeekOpen: typeof currentWeekOpen === 'number' ? currentWeekOpen : undefined,
        weeklyLimit: typeof weeklyLimit === 'number' ? weeklyLimit : undefined,
        totalLimit: typeof totalLimit === 'number' ? totalLimit : undefined
      })) : [],
      boxSeasonInfo: {
        startTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime) === 'string' && !isNaN(Date.parse(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime)) ? new Date(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.startTime).getTime() : undefined,
        endTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.endTime) === 'string' && !isNaN(Date.parse(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.endTime)) ? new Date(BoxSeasonInfo.endTime).getTime() : undefined,
        unlimitedAmount: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedAmount) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedAmount : false,
        unlimitedBuy: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedBuy) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedBuy : false,
        unlimitedTime: typeof (BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedTime) === 'boolean' ? BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.unlimitedTime : false,
        paymentToken: parsePaymentToken(BoxSeasonInfo === null || BoxSeasonInfo === void 0 ? void 0 : BoxSeasonInfo.paymentToken),
        userBoughtAmount: typeof userBoughtAmount === 'number' ? userBoughtAmount : 0,
        userLimitAmount: typeof userLimitAmount === 'number' ? userLimitAmount : 0
      },
      curSeasonId: typeof curSeasonId === 'number' ? curSeasonId : 0
    }
  };
});
export const getThetanBoxDashboardDetail = makeAPICaller('theta_data_get', '/thetanbox/dashboard/detail', res => {
  const {
    boxInfo,
    boxConfig,
    skinConfigs,
    paymentToken,
    boxConfigs
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      boxInfo: parseBoxInfo(boxInfo),
      paymentToken: parsePaymentToken(paymentToken),
      boxConfig: parseBoxConfig(boxConfig),
      skinConfigs: parseSkinConfig(skinConfigs),
      boxConfigVer: typeof (boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version) === 'number' ? boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version : undefined,
      boxConfigs: parseBoxConfigs(boxConfigs)
    }
  };
});
export const getGiftBoxDashboardDetail = makeAPICaller('theta_data_get', '/thetanbox/giftbox/dashboard/detail', res => {
  const {
    boxConfigs
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      boxInfo: parseGiftBoxInfo(res === null || res === void 0 ? void 0 : res.data),
      boxConfigVer: typeof (boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version) === 'number' ? boxConfigs === null || boxConfigs === void 0 ? void 0 : boxConfigs.version : undefined
    }
  };
});
export const getBoxConfig = makeAPICaller('theta_data_get', '/thetanbox/configs', res => {
  return {
    status: 'ok',
    body: parseBoxConfigsV2(res === null || res === void 0 ? void 0 : res.data)
  };
});
export const postBuyThetanBox = makeAPICaller('theta_data_post', '/thetanbox/buy-box', response => {
  const {
    blockchainId,
    boxId,
    boxType,
    price,
    paymentERC20,
    expiredAt,
    signature
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      id: typeof blockchainId === 'number' ? blockchainId : 0,
      boxId: typeof boxId === 'number' ? boxId : 0,
      boxType: typeof boxType === 'number' ? boxType : 0,
      price: typeof price === 'string' ? price : '',
      paymentErc20: typeof paymentERC20 === 'string' ? paymentERC20 : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      signature: typeof signature === 'string' ? signature : ''
    }
  };
});
export const confirmStake = makeAPICaller('theta_data_post', '/staking/stake', res => {
  const {
    stakeId,
    blockchainId,
    amount,
    signature,
    signatureExpiredAt,
    lockedDuration,
    tokenIds
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      stakeId: typeof stakeId === 'string' ? stakeId : '',
      blockchainId: typeof blockchainId === 'number' ? blockchainId : 0,
      amount: serverCurrencyToSystemCurrency(amount),
      signature: typeof signature === 'string' ? signature : '',
      expiredAt: typeof signatureExpiredAt === 'number' ? signatureExpiredAt : 0,
      lockedDuration: typeof lockedDuration === 'number' ? lockedDuration : 0,
      tokenIds: Array.isArray(tokenIds) ? tokenIds : []
    }
  };
});
export const getMyStaking = makeAPICaller('theta_data_get', '/staking/my-stake', response => {
  const {
    stakes,
    summary
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    availableTicket,
    reward,
    totalStaked
  } = summary || {};
  return {
    status: 'ok',
    body: {
      data: Array.isArray(stakes) ? stakes.map(unparsedData => parseMyStaking(unparsedData)) : [],
      summary: {
        availableTicket: serverCurrencyToSystemCurrency(availableTicket),
        pendingTHG: serverCurrencyToSystemCurrency(reward === null || reward === void 0 ? void 0 : reward.pendingTHG),
        pendingTicket: serverCurrencyToSystemCurrency(reward === null || reward === void 0 ? void 0 : reward.pendingTicket),
        thgClaimed: serverCurrencyToSystemCurrency(reward === null || reward === void 0 ? void 0 : reward.claimedTHG),
        totalStaked: serverCurrencyToSystemCurrency(totalStaked)
      }
    }
  };
});
export const getSpecialEventConfig = makeAPICaller('theta_data_get', '/specialevents/getConfigTournamentEvent', res => {
  const {
    eventId,
    eventType,
    eventStartIn,
    eventEndIn,
    dailyEventId,
    dailyEventType,
    dailyEventStartIn,
    dailyEventEndIn,
    bannerEventUrl,
    bannerMobileEventUrl,
    listOfRequiredHeroes,
    isJoined,
    priceTicket,
    trophyRequired
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      eventId: typeof eventId === 'number' ? eventId : 0,
      eventType: typeof eventType === 'string' ? eventType : '',
      eventStartIn: typeof eventStartIn === 'number' ? eventStartIn : 0,
      eventEndIn: typeof eventEndIn === 'number' ? eventEndIn : 0,
      dailyEventId: typeof dailyEventId === 'number' ? dailyEventId : 0,
      dailyEventType: typeof dailyEventType === 'string' ? dailyEventType : '',
      dailyEventStartIn: typeof dailyEventStartIn === 'number' ? dailyEventStartIn : 0,
      dailyEventEndIn: typeof dailyEventEndIn === 'number' ? dailyEventEndIn : 0,
      bannerEventUrl: typeof bannerEventUrl === 'string' ? bannerEventUrl : '',
      bannerMobileEventUrl: typeof bannerMobileEventUrl === 'string' ? bannerMobileEventUrl : '',
      listOfRequiredHeroes: Array.isArray(listOfRequiredHeroes) ? listOfRequiredHeroes.map(({
        heroTypeId,
        skinId,
        heroLevel,
        trophyLevel
      }) => ({
        heroTypeId: typeof heroTypeId === 'number' ? heroTypeId : 0,
        skinId: typeof skinId === 'number' ? skinId : 0,
        heroLevel: typeof heroLevel === 'number' ? heroLevel : 0,
        trophyLevel: typeof trophyLevel === 'number' ? trophyLevel : 0
      })) : [],
      isJoined: typeof isJoined === 'boolean' ? isJoined : false,
      priceTicket: priceTicket ? serverCurrencyToSystemCurrency(priceTicket) : {
        token: CurrencyType.GTHC,
        value: ''
      },
      trophyRequired: typeof trophyRequired === 'number' ? trophyRequired : 0
    }
  };
});
export const getSpecialEventLeaderboard = makeAPICaller('theta_leaderboard_get', '/leaderboard', res => {
  const {
    entries,
    mineLb,
    total
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const parseEntries = Array.isArray(entries) ? entries.map(parseLeaderboardData) : [];
  const parseMineLb = parseLeaderboardData(mineLb);
  return {
    status: 'ok',
    body: {
      total: typeof total === 'number' ? total : 0,
      entries: parseEntries,
      mineLb: mineLb ? parseMineLb : null
    }
  };
});
export const getListNotification = makeAPICaller('theta_data_get', '/callout', response => {
  const {
    notis,
    callout,
    expPick
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    callOutMess,
    tabEnum,
    expireAt,
    reward,
    callOutType
  } = callout || {};
  return {
    status: 'ok',
    body: {
      notis: Array.isArray(notis) ? notis : [],
      expPick: typeof expPick === 'number' ? expPick : 0,
      callout: callout ? {
        callOutMess: typeof callOutMess === 'string' ? callOutMess : '',
        tabEnum: typeof tabEnum == 'number' ? tabEnum : 0,
        expireAt: typeof expireAt === 'number' ? expireAt * 1000 : 0,
        reward: reward ? serverCurrencyToSystemCurrency(reward) : undefined,
        calloutType: typeof callOutType === 'number' ? callOutType : 0
      } : undefined
    }
  };
});
export const updateNotification = makeAPICaller('theta_data_post', '/callout/update', () => {
  return {
    status: 'ok',
    body: true
  };
});
export const putAvatarId = makeAPICaller('theta_data_put', '/profile/avatarId', () => {
  return {
    status: 'ok',
    body: undefined
  };
}, res => {
  const {
    success
  } = res || {};
  const code = AppError.UNNKOWN;

  if (!success) {
    return {
      status: 'error',
      error: code
    };
  }

  return {
    status: 'ok',
    body: undefined
  };
});
export const getSkinConfigs = makeAPICaller('theta_data_get', '/skin/configs', response => {
  return {
    status: 'ok',
    body: {
      skinConfigs: parseSkinConfig(response === null || response === void 0 ? void 0 : response.data)
    }
  };
});
export const getBoxPrice = makeAPICaller('theta_data_get', '/thetanbox/price', response => {
  const {
    price
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      price: {
        type: typeof (price === null || price === void 0 ? void 0 : price.type) === 'number' ? price.type : 0,
        name: typeof (price === null || price === void 0 ? void 0 : price.name) === 'string' ? price.name : '',
        value: typeof (price === null || price === void 0 ? void 0 : price.value) === 'number' ? price.value : 0,
        decimals: typeof (price === null || price === void 0 ? void 0 : price.decimals) === 'number' ? price.decimals : 0
      }
    }
  };
});
export const searchCosmeticList = makeAPICaller('theta_data_get', '/nif/search', response => {
  const {
    data,
    page
  } = response || {};
  const totalItems = typeof (page === null || page === void 0 ? void 0 : page.total) === 'number' ? page === null || page === void 0 ? void 0 : page.total : 0;
  const parsedData = Array.isArray(data) ? data.map(parseNftCosmetic) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedData
    }
  };
});
export const getCosmeticDetail = makeAPICaller('theta_data_get', '/cosmetics/{id}', response => {
  const data = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      data: parseCosmeticDetail(data)
    }
  };
});
export const getCosmeticSaleHistory = makeAPICaller('theta_report_get', '/item/cosmetic/{id}', response => {
  const {
    data,
    page
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (page === null || page === void 0 ? void 0 : page.total) === 'number' ? page === null || page === void 0 ? void 0 : page.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseCosmeticSaleHistory) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItems,
      totalItems
    }
  };
});
export const getSpecialEventRewards = makeAPICaller('theta_data_post', '/specialevents/claimReward', response => {
  let parsedResponse = undefined;

  if (response !== null && response !== void 0 && response.data) {
    const {
      rank,
      score,
      eventId,
      dailyEventId,
      rewards
    } = (response === null || response === void 0 ? void 0 : response.data) || {};
    parsedResponse = {
      rank: typeof rank === 'number' ? rank : 0,
      score: typeof score === 'number' ? score : 0,
      eventId: typeof eventId === 'number' ? eventId : 0,
      dailyEventId: typeof dailyEventId === 'number' ? dailyEventId : 0,
      rewards: {
        baseReward: serverCurrencyToSystemCurrency(rewards === null || rewards === void 0 ? void 0 : rewards.baseReward),
        bonusReward: serverCurrencyToSystemCurrency(rewards === null || rewards === void 0 ? void 0 : rewards.bonusReward)
      }
    };
  }

  return {
    status: 'ok',
    body: {
      data: parsedResponse // data === undefined means that user already claim special event rewards, and the modal will not show up in this case

    }
  };
});
export const getUserRanking = makeAPICaller('theta_data_get', '/userRanking', response => {
  var _response$data;

  const {
    id,
    trophy,
    rankingLevel,
    trophyCurRank,
    trophyHighest,
    rankingLevelHighest
  } = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.userRanking) || {};
  return {
    status: 'ok',
    body: {
      data: {
        id: typeof id === 'string' ? id : '',
        trophy: typeof trophy === 'number' ? trophy : 0,
        rankingLevel: typeof rankingLevel === 'number' ? rankingLevel : 0,
        rankingLevelHighest: typeof rankingLevelHighest === 'number' ? rankingLevelHighest : 0,
        trophyCurRank: typeof trophyCurRank === 'number' ? trophyCurRank : 0,
        trophyHighest: typeof trophyHighest === 'number' ? trophyHighest : 0
      }
    }
  };
});
export const getTradingEventTurn = makeAPICaller('theta_data_get', '/trading-event/turn', response => {
  const {
    id,
    seasonId,
    daily,
    cbMilestones
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    challenges,
    preReward
  } = daily || {};
  const parsedMilestones = [];
  Object.values(cbMilestones || {}).map(value => {
    parsedMilestones.push(value);
  });
  return {
    status: 'ok',
    body: {
      data: {
        id: typeof id === 'string' ? id : '',
        seasonId: typeof seasonId === 'number' ? seasonId : 0,
        daily: {
          challenges: Array.isArray(challenges) ? challenges.map(e => {
            const {
              type,
              required,
              refreshPrice,
              score,
              reward,
              status
            } = e;
            return {
              required: serverCurrencyToSystemCurrency(required),
              refreshPrice: serverCurrencyToSystemCurrency(refreshPrice),
              score: serverCurrencyToSystemCurrency(score),
              reward: serverCurrencyToSystemCurrency(reward),
              status: typeof status === 'number' ? status : 0,
              type: typeof type === 'number' ? type : 0
            };
          }) : []
        },
        preReward: serverCurrencyToSystemCurrency(preReward),
        cbMilestones: parsedMilestones
      }
    }
  };
});
export const postJoinSpecialEvent = makeAPICaller('theta_data_post', '/specialevents/join', () => {
  return {
    status: 'ok',
    body: {
      data: null
    }
  };
});
export const getVestingSafeRemainingClaimCount = makeAPICaller('theta_data_get', '/vesting-safe/remaining-claim', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: typeof data === 'number' ? data : 0
    }
  };
});
export const postClaimVestingSafe = makeAPICaller('theta_data_post', '/vesting-safe/claim', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: serverCurrencyToSystemCurrency(data)
    }
  };
});
export const getProjectList = makeAPICaller('theta_data_get', '/private-sales/projects', response => {
  const {
    data
  } = response || {};
  const parsedItem = Array.isArray(data) ? data.map(parseProjectDetail) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItem
    }
  };
});
export const getUserProject = makeAPICaller('theta_data_get', '/private-sales/user-project/{id}', response => {
  const {
    data
  } = response || {};
  const {
    id,
    userID,
    userAddress,
    otherChainAddress,
    projectID,
    status,
    blockNumber,
    txHash,
    blockchainID,
    busdAmount,
    thcAmount,
    fee,
    pTicketAmount,
    pricePerToken,
    created,
    refundInfo
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        blockNumber: typeof blockNumber === 'number' ? blockNumber : 0,
        blockchainId: typeof blockchainID === 'number' ? blockchainID : 0,
        busdAmount: serverCurrencyToSystemCurrency(busdAmount),
        thcAmount: serverCurrencyToSystemCurrency(thcAmount),
        fee: typeof fee === 'number' ? fee : 0,
        id: typeof id === 'string' ? id : '',
        otherChainAddress: typeof otherChainAddress === 'string' ? otherChainAddress : '',
        pTicketAmount: serverCurrencyToSystemCurrency(pTicketAmount),
        pricePerToken: serverCurrencyToSystemCurrency(pricePerToken),
        projectId: typeof projectID === 'string' ? projectID : '',
        status: typeof status === 'number' ? status : 0,
        txHash: typeof txHash === 'string' ? txHash : '',
        userAddress: typeof userAddress === 'string' ? userAddress : '',
        userId: typeof userID === 'string' ? userID : '',
        created: typeof created === 'string' && !isNaN(Date.parse(created)) ? Date.parse(created) : undefined,
        refundInfo: refundInfo ? {
          txHash: typeof refundInfo.txHash === 'string' ? refundInfo.txHash : ''
        } : undefined
      }
    }
  };
});
export const getMyProjectList = makeAPICaller('theta_data_get', '/private-sales/projects/my-launches', response => {
  const {
    data
  } = response || {};
  const parsedItem = Array.isArray(data) ? data.map(parseProjectDetail) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItem
    }
  };
});
export const getFusionSeason = makeAPICaller('theta_data_get', '/fusion', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: parseFusionSeason(data)
    }
  };
});
export const fetchHomeBanner = makeAPICaller('theta_data_get', '/mkpdashboard/banner/getlist', response => {
  const {
    data
  } = response || {};
  const {
    listBanner,
    timeout
  } = data || {};
  return {
    status: 'ok',
    body: {
      timeout: typeof timeout === 'number' ? timeout : 0,
      data: Array.isArray(listBanner) ? listBanner.map(e => ({
        id: typeof e.id === 'number' ? e.id : 0,
        bgImageDesktop: typeof e.bgImageDesktop === 'string' ? e.bgImageDesktop : '',
        bgImageMobile: typeof e.bgImageMobile === 'string' ? e.bgImageMobile : '',
        ctaLink: typeof e.ctaLink === 'string' ? e.ctaLink : ''
      })) : []
    }
  };
});
export const fetchCosmeticListed = makeAPICaller('theta_data_get', '/mkpdashboard/cosmetic/getrecentlylisted', response => {
  const {
    data
  } = response || {};
  const {
    timeout,
    listItem
  } = data || {};
  const parsedItems = Array.isArray(listItem) ? listItem.map(parseNftCosmeticRecently) : [];
  return {
    status: 'ok',
    body: {
      timeout: typeof timeout === 'number' ? timeout : 0,
      listItem: parsedItems
    }
  };
});
export const fetchCosmeticTraded = makeAPICaller('theta_data_get', '/mkpdashboard/cosmetic/getrecentlytraded', response => {
  const {
    data
  } = response || {};
  const {
    timeout,
    listItem,
    page
  } = data || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(listItem) ? listItem.map(parseNftCosmeticRecently) : [];
  return {
    status: 'ok',
    body: {
      data: {
        timeout: typeof timeout === 'number' ? timeout : 0,
        listItem: parsedItems
      },
      totalItems
    }
  };
});
export const fetchHeroesListed = makeAPICaller('theta_data_get', '/mkpdashboard/hero/getrecentlylisted', response => {
  const {
    data
  } = response || {};
  const {
    timeout,
    listItem
  } = data || {};
  const parsedItems = Array.isArray(listItem) ? listItem.map(parseNftHeroRecently) : [];
  return {
    status: 'ok',
    body: {
      timeout: typeof timeout === 'number' ? timeout : 0,
      listItem: parsedItems
    }
  };
});
export const fetchHeroesTraded = makeAPICaller('theta_data_get', '/mkpdashboard/hero/getrecentlytraded', response => {
  const {
    data
  } = response || {};
  const {
    timeout,
    listItem,
    page
  } = data || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(listItem) ? listItem.map(parseNftHeroRecently) : [];
  return {
    status: 'ok',
    body: {
      data: {
        timeout: typeof timeout === 'number' ? timeout : 0,
        listItem: parsedItems
      },
      totalItems
    }
  };
});
export const fetchMetricStatDashboard = makeAPICaller('theta_data_get', '/mkpdashboard/metric/getmetricstats', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      timeout: typeof (data === null || data === void 0 ? void 0 : data.timeout) === 'number' ? data.timeout : 0,
      listedCount: typeof (data === null || data === void 0 ? void 0 : data.listedCount) === 'number' ? data.listedCount : 0,
      transactionRealValue: typeof (data === null || data === void 0 ? void 0 : data.transactionRealValue) === 'number' ? data.transactionRealValue : 0,
      transactionValue: normalNumberToSystemCurrency(typeof (data === null || data === void 0 ? void 0 : data.transactionRealValue) === 'number' ? data.transactionRealValue : 0, CurrencyType.THC),
      tradedCount: typeof (data === null || data === void 0 ? void 0 : data.tradedCount) === 'number' ? data.tradedCount : 0
    }
  };
});
export const getFusionCost = makeAPICaller('theta_data_put', '/fusion/cost', response => {
  const {
    data
  } = response || {};
  const {
    cost,
    expiredTime
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        cost: serverCurrencyToSystemCurrency(cost),
        expiredTime: typeof expiredTime === 'number' ? expiredTime * 1000 : 0
      }
    }
  };
});
export const refreshOutputFusion = makeAPICaller('theta_data_put', '/fusion/refresh', response => {
  const {
    data
  } = response || {};
  const {
    output,
    refrCost
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        outputSkinId: typeof output === 'number' ? output : 0,
        refreshCost: serverCurrencyToSystemCurrency(refrCost)
      }
    }
  };
});
export const confirmFuse = makeAPICaller('theta_data_post', '/fusion/turn', response => {
  const {
    data
  } = response || {};
  const {
    amount,
    expiredAt,
    signature,
    sender,
    tokenIds,
    blockchainId,
    skinInfo,
    heroInfo
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        amount: typeof amount === 'string' ? amount : '',
        expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
        signature: typeof signature === 'string' ? signature : '',
        sender: typeof sender === 'string' ? sender : '',
        tokenIds: Array.isArray(tokenIds) ? tokenIds : [],
        blockchainId: typeof blockchainId === 'number' ? blockchainId : 0,
        heroInfo: {
          name: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.name) === 'string' ? heroInfo.name : '',
          rarity: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.rarity) === 'number' ? heroInfo.rarity : 0
        },
        skinInfo: {
          imageFull: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.imageFull) === 'string' ? skinInfo.imageFull : '',
          name: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.name) === 'string' ? skinInfo.name : '',
          skinRarity: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.skinRarity) === 'number' ? skinInfo.skinRarity : 0
        }
      }
    }
  };
});
export const postPrevFusionReward = makeAPICaller('theta_data_post', '/fusion/reward', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: {
        lb: data !== null && data !== void 0 && data.lb ? serverCurrencyToSystemCurrency(data.lb) : undefined,
        cashback: data !== null && data !== void 0 && data.cashback ? serverCurrencyToSystemCurrency(data.cashback) : undefined
      }
    }
  };
});
export const getFusionTurn = makeAPICaller('theta_data_get', '/fusion/turn', response => {
  const {
    data
  } = response || {};
  const {
    inpHeroes,
    outHeroes,
    fusionCost,
    refreshCost,
    costExpired,
    endTime,
    status,
    seasonId,
    cbMilestones,
    fuseTime
  } = data || {};
  const parsedData = [];
  Object.values(cbMilestones || {}).map(value => {
    parsedData.push(value);
  });
  return {
    status: 'ok',
    body: {
      data: {
        skinsRequired: Array.isArray(inpHeroes) ? inpHeroes : [],
        skinsResult: Array.isArray(outHeroes) ? outHeroes : [],
        fusionCost: serverCurrencyToSystemCurrency(fusionCost),
        refreshCost: serverCurrencyToSystemCurrency(refreshCost),
        costExpiredAt: typeof costExpired === 'number' ? costExpired : 0,
        endTime: typeof endTime === 'number' ? endTime * 1000 : 0,
        status: typeof status === 'number' ? status : 0,
        seasonId: typeof seasonId === 'number' ? seasonId : 0,
        cbMilestones: parsedData,
        fuseTime: typeof fuseTime === 'number' ? fuseTime : 0
      }
    }
  };
});
export const getBattleCapHeroFusion = makeAPICaller('theta_data_get', '/config', response => {
  const {
    battleCapCfg,
    version
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    battleCapConfig
  } = battleCapCfg || {};
  return {
    status: 'ok',
    body: {
      configVer: typeof version === 'number' ? version : 0,
      data: parseBattleCapHeroData(battleCapConfig)
    }
  };
});
export const postClaimCashback = makeAPICaller('theta_data_post', '/fusion/reward/cashback', response => {
  return {
    status: 'ok',
    body: {
      data: Boolean(response)
    }
  };
});
export const getFusionLeaderboard = makeAPICaller('theta_data_get', '/fusion/lb', res => {
  const {
    entries,
    mineLb,
    total,
    encourage
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const parseEntries = Array.isArray(entries) ? entries.map(parseFusionLeaderboardData) : [];
  const parseMineLb = parseFusionLeaderboardData(mineLb);
  return {
    status: 'ok',
    body: {
      total: typeof total === 'number' ? total : 0,
      entries: parseEntries,
      mineLb: mineLb ? parseMineLb : null,
      encourage: encourage ? {
        closestRank: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.closestRank) === 'number' ? encourage.closestRank : 0,
        requireScore: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.requireScore) === 'number' && // when 2 users have the same score, the requested score will be returned as 1
        (encourage === null || encourage === void 0 ? void 0 : encourage.requireScore) !== 1 ? {
          token: CurrencyType.THC,
          value: encourage.requireScore
        } : {
          token: CurrencyType.THC,
          value: '100000000'
        },
        reward: serverCurrencyToSystemCurrency(encourage === null || encourage === void 0 ? void 0 : encourage.reward)
      } : undefined
    }
  };
});
export const getSpecialEventList = makeAPICaller('theta_data_get', '/specialevents/getEventsProfile', response => {
  const {
    data
  } = response || {};
  const parsedItem = Array.isArray(data) ? data.map(parseSpecialEventProfile) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItem
    }
  };
});
export const getQuestConfig = makeAPICaller('theta_data_get', '/mkp-quests/configs', res => {
  const {
    quests,
    startQuestRewards,
    questPointUnit,
    questCountInStage,
    intervalQuestRewards,
    minStageQuestRewards_1,
    minStageQuestRewards_2
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      data: Array.isArray(quests) ? quests.map(({
        id,
        title,
        description,
        iconImage,
        directURLs
      }) => {
        return {
          id: typeof id === 'number' ? id : 0,
          title: typeof title === 'string' ? title : '',
          description: typeof description === 'string' ? description : '',
          iconImage: typeof iconImage === 'string' ? iconImage : '',
          directURLs: typeof directURLs === 'string' ? directURLs : ''
        };
      }) : [],
      rewardConfig: {
        startQuestRewards: typeof startQuestRewards === 'number' ? startQuestRewards : 0,
        questPointUnit: typeof questPointUnit === 'number' ? questPointUnit : 0,
        intervalQuestRewards: typeof intervalQuestRewards === 'number' ? intervalQuestRewards : 0,
        minStageQuestRewards_1: typeof minStageQuestRewards_1 === 'number' ? minStageQuestRewards_1 : 0,
        minStageQuestRewards_2: typeof minStageQuestRewards_2 === 'number' ? minStageQuestRewards_2 : 0,
        questCountInStage: parseQuestCountInStage(questCountInStage)
      }
    }
  };
});
export const getMyQuestStages = makeAPICaller('theta_data_get', '/mkp-quests/my-quests', response => {
  const {
    currentStage,
    quests,
    expiredTime,
    questPointEachStage,
    stagesReward,
    rewardAutoClaim
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      currentStage: typeof currentStage === 'number' ? currentStage : 0,
      expiredTime: typeof expiredTime === 'number' ? expiredTime * 1000 : 0,
      quests: parseMyQuestStagesData(quests),
      questPointEachStage: parseQuestPointEachStageData(questPointEachStage),
      stagesReward: parseStagesRewardData(stagesReward),
      rewardAutoClaim: typeof rewardAutoClaim === 'object' ? serverCurrencyToSystemCurrency(rewardAutoClaim) : undefined
    }
  };
});
export const claimQuestReward = makeAPICaller('theta_data_post', '/mkp-quests/claim-reward', response => {
  const {
    code
  } = response || {};
  return {
    status: 'ok',
    body: {
      code: typeof code === 'number' ? code : 0
    }
  };
});
export const refreshQuest = makeAPICaller('theta_data_post', '/mkp-quests/refresh', response => {
  const {
    code
  } = response || {};
  return {
    status: 'ok',
    body: {
      code: typeof code === 'number' ? code : 0
    }
  };
});
export const getQuestLeaderboard = makeAPICaller('theta_data_get', '/mkp-quests/leaderboard', res => {
  const {
    entries,
    mineLb,
    total,
    endTime,
    autoClaimedReward,
    encourage
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const parseEntries = Array.isArray(entries) ? entries.map(parseQuestLeaderboardData) : [];
  const parseMineLb = parseQuestLeaderboardData(mineLb);
  return {
    status: 'ok',
    body: {
      total: typeof total === 'number' ? total : 0,
      entries: parseEntries,
      mineLb: mineLb ? parseMineLb : null,
      endTime: typeof endTime === 'number' ? endTime * 1000 : 0,
      autoClaimedReward: typeof autoClaimedReward === 'object' ? serverCurrencyToSystemCurrency(autoClaimedReward) : undefined,
      encourage: encourage ? {
        closestRank: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.closestRank) === 'number' ? encourage.closestRank : 0,
        requireScore: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.requireScore) === 'number' ? encourage.requireScore : 0,
        reward: serverCurrencyToSystemCurrency(encourage === null || encourage === void 0 ? void 0 : encourage.reward)
      } : undefined
    }
  };
});
export const getDailyQuestReward = makeAPICaller('theta_data_get', '/mkp-quests/daily-challenge', res => {
  return {
    status: 'ok',
    body: parseDailyQuestReward(res === null || res === void 0 ? void 0 : res.data)
  };
});
export const claimDailyQuestReward = makeAPICaller('theta_data_post', '/mkp-quests/daily-challenge/check-in', response => {
  const {
    blockchainId,
    boxId,
    boxType,
    price,
    paymentERC20,
    expiredAt,
    signature
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      id: typeof blockchainId === 'number' ? blockchainId : 0,
      boxId: typeof boxId === 'number' ? boxId : 0,
      boxType: typeof boxType === 'number' ? boxType : 0,
      price: typeof price === 'string' ? price : '',
      paymentErc20: typeof paymentERC20 === 'string' ? paymentERC20 : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      signature: typeof signature === 'string' ? signature : ''
    }
  };
}); // TODO

export const signSignatureClaimWheelTicket = makeAPICaller('theta_data_post', '/giftmaswheel/claim-ticket', response => {
  const {
    blockchainId,
    boxId,
    boxType,
    price,
    paymentERC20,
    expiredAt,
    signature
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      id: typeof blockchainId === 'number' ? blockchainId : 0,
      boxId: typeof boxId === 'number' ? boxId : 0,
      boxType: typeof boxType === 'number' ? boxType : 0,
      price: typeof price === 'string' ? price : '',
      paymentErc20: typeof paymentERC20 === 'string' ? paymentERC20 : '',
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      signature: typeof signature === 'string' ? signature : ''
    }
  };
});
export const getQuestBox = makeAPICaller('theta_data_get', '/mkp-quests/boxes/info', res => {
  return {
    status: 'ok',
    body: parseQuestBox(res === null || res === void 0 ? void 0 : res.data)
  };
});
export const claimStreakReward = makeAPICaller('theta_data_post', '/mkp-quests/daily-challenge/claim-streak', () => {
  return {
    status: 'ok',
    body: {
      success: true
    }
  };
});
export const postClaimQuestBox = makeAPICaller('theta_data_post', '/mkp-quests/boxes/claim', () => {
  return {
    status: 'ok',
    body: {
      success: true
    }
  };
});
export const getCoinbaseLootConfigs = makeAPICaller('theta_data_get', '/specialevents/getConfigCoinbaseEvent', response => {
  const {
    data
  } = response || {};
  const {
    eventId,
    startIn,
    endIn,
    duration,
    bannerURL,
    bannerMobileURL,
    bannerDetailURL,
    directURLEvent
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        eventId: typeof eventId === 'number' ? eventId : 0,
        startIn: typeof startIn === 'number' ? startIn : 0,
        endIn: typeof endIn === 'number' ? endIn : 0,
        duration: typeof duration === 'number' ? duration : 0,
        bannerURL: typeof bannerURL === 'string' ? bannerURL : '',
        bannerMobileURL: typeof bannerMobileURL === 'string' ? bannerMobileURL : '',
        bannerDetailURL: typeof bannerDetailURL === 'string' ? bannerDetailURL : '',
        directURLEvent: typeof directURLEvent === 'string' ? directURLEvent : ''
      }
    }
  };
});
export const getTradingEventSeasonData = makeAPICaller('theta_data_get', '/trading-event', response => {
  const {
    data
  } = response || {};
  const {
    id,
    startTime,
    endTime,
    cashback,
    quest,
    warmUp,
    config,
    dailyEndTime
  } = data || {};
  const {
    type,
    heroTrophyClass,
    heroLevel,
    heroClass,
    skinRarity,
    subId
  } = quest || {};
  const {
    version,
    daily,
    questImg,
    questMobileImg
  } = config || {};
  return {
    status: 'ok',
    body: {
      data: {
        id: typeof id === 'number' ? id : 0,
        startTime: typeof startTime === 'string' ? Date.parse(startTime) : 0,
        endTime: typeof endTime === 'string' ? Date.parse(endTime) : 0,
        cashback: Array.isArray(cashback) ? cashback.map(cb => ({
          reward: serverCurrencyToSystemCurrency(cb === null || cb === void 0 ? void 0 : cb.reward),
          score: serverCurrencyToSystemCurrency(cb === null || cb === void 0 ? void 0 : cb.score)
        })) : [],
        quest: {
          type: typeof type === 'number' ? type : TradingQuestType.HERO_CLASS,
          heroTrophyClass: typeof heroTrophyClass === 'number' ? heroTrophyClass : undefined,
          heroLevel: heroLevel && typeof heroLevel === 'number' ? heroLevel : undefined,
          heroClass: typeof heroClass === 'number' ? heroClass : undefined,
          skinRarity: typeof skinRarity === 'number' ? skinRarity : undefined,
          subId: typeof subId === 'number' ? subId : 0
        },
        warmUp: Array.isArray(warmUp) ? warmUp.map(item => parseTradingEventWarmup(item)) : [],
        dailyEndTime: typeof dailyEndTime === 'string' ? Date.parse(dailyEndTime) : 0
      },
      config: !!version && daily ? {
        version: typeof version === 'number' ? version : 0,
        questImg: typeof questImg === 'string' ? questImg : '',
        questMobileImg: typeof questMobileImg === 'string' ? questMobileImg : '',
        daily: {
          dailyImg: typeof (daily === null || daily === void 0 ? void 0 : daily.dailyImg) === 'string' ? daily.dailyImg : '',
          challenges: daily !== null && daily !== void 0 && daily.challenges && Array.isArray(daily === null || daily === void 0 ? void 0 : daily.challenges) ? daily.challenges.map(e => {
            return {
              type: typeof e.type === 'number' ? e.type : 0,
              description: typeof e.description === 'string' ? e.description : ''
            };
          }) : []
        }
      } : undefined
    }
  };
});
export const putClaimTradingEventDailyChallenge = makeAPICaller('theta_data_put', '/trading-event/daily/claim', response => {
  return {
    status: 'ok',
    body: {
      data: Boolean(response)
    }
  };
});
export const putClaimPreTradingEventDailyReward = makeAPICaller('theta_data_put', '/trading-event/daily/claim-pre', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: data ? serverCurrencyToSystemCurrency(data) : undefined
    }
  };
});
export const putClaimTradingEventCashback = makeAPICaller('theta_data_put', '/trading-event/cashback/claim', response => {
  return {
    status: 'ok',
    body: {
      data: Boolean(response)
    }
  };
});
export const putClaimAllTradingEventRewards = makeAPICaller('theta_data_put', '/trading-event/claim', response => {
  const {
    data
  } = response || {};
  const {
    daily,
    lb,
    cashback
  } = data || {};
  return {
    status: 'ok',
    body: {
      data: {
        daily: daily ? serverCurrencyToSystemCurrency(daily) : undefined,
        lb: lb ? serverCurrencyToSystemCurrency(lb) : undefined,
        cashback: cashback ? serverCurrencyToSystemCurrency(cashback) : undefined
      }
    }
  };
});
export const getTradingEventLeaderboard = makeAPICaller('theta_data_get', '/trading-event/lb', res => {
  const {
    entries,
    mineLb,
    total,
    encourage
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  const parseEntries = Array.isArray(entries) ? entries.map(parseFusionLeaderboardData) : [];
  const parseMineLb = parseFusionLeaderboardData(mineLb);
  return {
    status: 'ok',
    body: {
      total: typeof total === 'number' ? total : 0,
      entries: parseEntries,
      mineLb: mineLb ? parseMineLb : null,
      encourage: encourage ? {
        closestRank: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.closestRank) === 'number' ? encourage === null || encourage === void 0 ? void 0 : encourage.closestRank : 0,
        requireScore: typeof (encourage === null || encourage === void 0 ? void 0 : encourage.requireScore) === 'number' && // when 2 users have the same score, the requested score will be returned as 1
        (encourage === null || encourage === void 0 ? void 0 : encourage.requireScore) !== 1 ? {
          token: CurrencyType.THC,
          value: encourage.requireScore
        } : {
          token: CurrencyType.THC,
          value: '100000000'
        },
        reward: serverCurrencyToSystemCurrency(encourage === null || encourage === void 0 ? void 0 : encourage.reward)
      } : undefined
    }
  };
});
export const logVisitPageDB = makeAPICaller('theta_data_post', '/tracking?event=visit-page', response => {
  return {
    status: 'ok',
    body: {
      data: Boolean(response)
    }
  };
});
export const getPopupConfig = makeAPICaller('admin_config_get', '/remote-config/view', response => {
  return {
    status: 'ok',
    body: parsePopupConfig(response)
  };
});
export const getSamsungEvent = makeAPICaller('theta_data_get', '/specialevents/samsung', response => {
  const {
    boxType,
    requiredBattle,
    downloadLink,
    claimLink,
    startTime,
    endTime
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      data: {
        boxType: typeof boxType === 'number' ? boxType : undefined,
        requiredBattle: typeof requiredBattle === 'number' ? requiredBattle : 0,
        downloadLink: typeof downloadLink === 'string' ? downloadLink : '',
        claimLink: typeof claimLink === 'string' ? claimLink : '',
        startTime: typeof startTime === 'number' ? startTime : 0,
        endTime: typeof endTime === 'number' ? endTime : 0
      }
    }
  };
});
export const getGiftmasWheel = makeAPICaller('theta_data_get', '/giftmaswheel/get-giftmas-wheel', response => {
  return {
    status: 'ok',
    body: {
      data: parseGiftmasWheel(response)
    }
  };
});
export const getWheelReward = makeAPICaller('theta_data_post', '/giftmaswheel/claim-wheel-reward', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: Array.isArray(data) ? data.map(reward => ({
        name: typeof reward.name === 'string' ? reward.name : '',
        rewardType: typeof reward.rewardType === 'string' ? reward.rewardType : RewardType.HERO,
        amount: typeof reward.amount === 'number' ? reward.amount : 0,
        subId: typeof reward.subId === 'number' ? reward.subId : 0,
        receivedTime: typeof reward.receivedTime === 'string' ? reward.receivedTime : ''
      })) : []
    }
  };
});
export const postCombineLogo = makeAPICaller('theta_data_post', '/giftmaswheel/combine-logo', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: Array.isArray(data) ? data.map(reward => ({
        name: typeof reward.name === 'string' ? reward.name : '',
        rewardType: typeof reward.rewardType === 'string' ? reward.rewardType : RewardType.HERO,
        amount: typeof reward.amount === 'number' ? reward.amount : 0,
        subId: typeof reward.subId === 'number' ? reward.subId : 0,
        receivedTime: typeof reward.receivedTime === 'string' ? reward.receivedTime : ''
      })) : []
    }
  };
});
export const searchInventory = makeAPICaller('theta_data_get', '/hero/user', response => {
  var _data$skinConfigs, _data$skinConfigs2;

  const {
    page,
    data
  } = response || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(data === null || data === void 0 ? void 0 : data.heroes) ? (data === null || data === void 0 ? void 0 : data.heroes).map(parseNftHeroInventory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      heroes: parsedItems,
      skinConfigs: parseSkinConfigEntities(data === null || data === void 0 ? void 0 : data.skinConfigs),
      skinVer: typeof (data === null || data === void 0 ? void 0 : (_data$skinConfigs = data.skinConfigs) === null || _data$skinConfigs === void 0 ? void 0 : _data$skinConfigs.version) === 'number' ? data === null || data === void 0 ? void 0 : (_data$skinConfigs2 = data.skinConfigs) === null || _data$skinConfigs2 === void 0 ? void 0 : _data$skinConfigs2.version : undefined
    }
  };
});
export const parseNftHeroInventory = hero => {
  const {
    id,
    ownerId,
    tokenId,
    refId,
    refType,
    sale,
    heroTypeId,
    heroRarity,
    skinId,
    skinRarity,
    status,
    marketStatus,
    level,
    imageAvatar,
    imageFull,
    heroRanking,
    heroInfo,
    rarity,
    ownerAddress,
    thcBonus,
    dailyTHCBattleConfig
  } = hero;
  return {
    id: typeof id === 'string' ? id : '',
    ownerId: typeof ownerId === 'string' ? ownerId : '',
    tokenId: typeof tokenId === 'string' ? tokenId : '',
    refId: typeof refId === 'string' ? refId : '',
    refType: typeof refType === 'string' ? refType : NftRefType.HERO,
    systemPrice: sale !== null && sale !== void 0 && sale.price ? serverCurrencyToSystemCurrency(sale === null || sale === void 0 ? void 0 : sale.price) : undefined,
    hp: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.hp) === 'number' ? heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.hp : 0,
    dmg: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.dmg) === 'number' ? heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.dmg : 0,
    heroTypeId: typeof heroTypeId === 'number' ? heroTypeId : 0,
    heroRarity: typeof heroRarity === 'number' ? heroRarity : NftItemRarity.COMMON,
    skinId: typeof skinId === 'number' ? skinId : 0,
    skinRarity: typeof skinRarity === 'number' ? skinRarity : NftSkinItemRarity.NORMAL,
    status: typeof status === 'number' ? status : HeroStatus.DEFAULT,
    marketStatus: typeof marketStatus === 'number' ? marketStatus : 0,
    level: typeof level === 'number' ? level : 0,
    trophy: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.trophyClass) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.trophyClass : HeroTrophy.H,
    imageAvatar: typeof imageAvatar === 'string' ? imageAvatar : '',
    imageFull: typeof imageFull === 'string' ? imageFull : '',
    name: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.name) === 'string' ? heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.name : '',
    rarity: typeof rarity === 'number' ? rarity : NftItemRarity.COMMON,
    heroRole: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.role) === 'number' ? heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.role : NtfHeroClassType.TANK,
    ownerAddress: typeof ownerAddress === 'string' ? ownerAddress : '',
    battleCap: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.battleCapTHC) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.battleCapTHC : 0,
    battleCapMax: typeof (heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.totalBattleCapTHC) === 'number' ? heroRanking === null || heroRanking === void 0 ? void 0 : heroRanking.totalBattleCapTHC : 0,
    thcBonus: typeof thcBonus === 'number' ? thcBonus : 0,
    dailyTHCBattleConfig: typeof dailyTHCBattleConfig === 'number' ? dailyTHCBattleConfig : 0
  };
};
export const putWalletConnect = makeAPICaller('theta_data_put', '/user/walletConnect', () => {
  return {
    status: 'ok',
    body: {
      success: true
    }
  };
});
export const getThetanWorldConfigApi = makeAPICaller('admin_config_get', '/remote-config/view?name=thetan_world.campaign&raw=true', response => {
  const {
    connectWallet
  } = response || {};
  const {
    startTime,
    endTime
  } = connectWallet || {};

  if (typeof startTime !== 'string' || typeof endTime !== 'string') {
    return {
      status: 'error',
      error: AppError.REJECTED_BY_FE,
      debugMessage: 'invalid data'
    };
  }

  const isInCampaign = new Date().getTime() >= new Date(startTime).getTime() && new Date().getTime() <= new Date(endTime).getTime();
  return {
    status: 'ok',
    body: {
      connectWallet: isInCampaign
    }
  };
});